import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG = 'HAFTPFLICHT-SACHSCHADEN-KABEL-LEITUNG';

export type HaftpflichtSachschadenKabelLeitungModelConfig = BaseHaftpflichtSchadenModelConfig;

export class HaftpflichtSachschadenKabelLeitungModel extends BaseHaftpflichtSchadenModel {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG;

  constructor(config: HaftpflichtSachschadenKabelLeitungModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
